(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-industrial-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var root = event.target.closest('[data-zv-pdp]');
    if (!root) return;
    var thumb = event.target.closest('[data-zv-thumb]');
    if (thumb) {
      var mainImage = root.querySelector('[data-zv-main-image]');
      if (mainImage) mainImage.src = thumb.getAttribute('data-zv-thumb');
      root.querySelectorAll('[data-zv-thumb]').forEach(function(button) { button.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
    if (event.target.matches('[data-zv-qty-minus], [data-zv-qty-plus]')) {
      var input = root.querySelector('[data-zv-qty]');
      if (!input) return;
      var value = parseInt(input.value || '1', 10);
      if (event.target.matches('[data-zv-qty-plus]')) value += 1;
      if (event.target.matches('[data-zv-qty-minus]')) value -= 1;
      input.value = Math.max(1, value);
    }
  });
  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-zv-variant-select]')) return;
    var root = event.target.closest('[data-zv-pdp]');
    var option = event.target.options[event.target.selectedIndex];
    if (!root || !option) return;
    var price = option.getAttribute('data-price');
    var compare = option.getAttribute('data-compare');
    var available = option.getAttribute('data-available') === 'true';
    root.querySelectorAll('[data-zv-price], [data-zv-card-price]').forEach(function(node) { if (price) node.textContent = price; });
    root.querySelectorAll('[data-zv-compare]').forEach(function(node) { node.textContent = compare || ''; });
    var submit = root.querySelector('[name="add"]');
    if (submit) submit.disabled = !available;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-vevor-results"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.zupper-search-page-form');
    if (!form) return;
    const input = form.querySelector('input[type="search"]');
    const category = form.querySelector('[data-search-page-category]');
    const normalized = input && input.value ? input.value.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-') : '';
    if (!input || !category || !category.value || !input.value.trim()) return;
    input.value = `${input.value.trim()} ${category.value.trim()}`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zupper-about-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stats = document.querySelectorAll('.zupper-about-stat[data-count]');
    if (!stats.length) return;
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const parseNumber = value => {
      const match = String(value).match(/\d+/);
      return match ? Number(match[0]) : 0;
    };

    const animate = entry => {
      const node = entry.target;
      const raw = node.getAttribute('data-count') || '';
      const target = parseNumber(raw);
      if (!target || node.dataset.done) return;
      node.dataset.done = 'true';
      const suffix = raw.replace(String(target), '');
      if (reduceMotion) {
        node.textContent = `${target}${suffix}`;
        return;
      }
      const start = performance.now();
      const duration = 900;
      const frame = now => {
        const progress = Math.min((now - start) / duration, 1);
        node.textContent = `${Math.round(target * progress)}${suffix}`;
        if (progress < 1) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    };

    if (!('IntersectionObserver' in window)) {
      stats.forEach(node => animate({ target: node }));
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animate(entry);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    stats.forEach(node => observer.observe(node));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zupper-storefront-home"]) return;
  try {
    
  (function () {
    function initApplicationNavigator(navigatorElement) {
      if (!navigatorElement || navigatorElement.getAttribute('data-zs-application-initialized') === 'true') return;
      navigatorElement.setAttribute('data-zs-application-initialized', 'true');

      var enhanced = navigatorElement.querySelector('.zs-application-navigator__enhanced');
      var fallback = navigatorElement.querySelector('[data-zs-application-fallback]');
      var panels = Array.prototype.slice.call(navigatorElement.querySelectorAll('[data-zs-application-panel]'));
      var controls = Array.prototype.slice.call(navigatorElement.querySelectorAll('[data-zs-application-control]'));
      var cta = navigatorElement.querySelector('[data-zs-application-cta]');

      function activate(index) {
        if (index < 0 || index >= panels.length || index >= controls.length) return;
        panels.forEach(function (panel, panelIndex) {
          panel.classList.toggle('is-active', panelIndex === index);
        });
        controls.forEach(function (control, controlIndex) {
          var active = controlIndex === index;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (cta) {
          cta.textContent = controls[index].getAttribute('data-cta-label');
          cta.href = controls[index].getAttribute('data-cta-url');
        }
      }

      controls.forEach(function (control) {
        control.addEventListener('click', function () {
          activate(parseInt(control.getAttribute('data-zs-application-control'), 10));
        });
        control.addEventListener('focus', function () {
          activate(parseInt(control.getAttribute('data-zs-application-control'), 10));
        });
      });

      navigatorElement.classList.add('is-enhanced');
      if (enhanced) enhanced.setAttribute('aria-hidden', 'false');
      if (fallback) fallback.setAttribute('aria-hidden', 'true');
      activate(0);
    }

    function initApplicationNavigators() {
      document.querySelectorAll('[data-zs-application-navigator]').forEach(initApplicationNavigator);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initApplicationNavigators, { once: true });
    } else {
      initApplicationNavigators();
    }
  })();

  (function () {
    function initManufacturingStory(story) {
      if (!story || story.getAttribute('data-zs-manufacturing-initialized') === 'true') return;
      story.setAttribute('data-zs-manufacturing-initialized', 'true');

      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var saveData = Boolean(connection && connection.saveData);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var enhanced = story.querySelector('.zs-manufacturing-story__enhanced');
      var fallback = story.querySelector('[data-zs-manufacturing-fallback]');
      var panels = Array.prototype.slice.call(story.querySelectorAll('[data-zs-manufacturing-panel]'));
      var controls = Array.prototype.slice.call(story.querySelectorAll('[data-zs-manufacturing-control]'));
      var activeIndex = 0;
      var resizeFrame = 0;

      function activate(index) {
        if (index < 0 || index >= panels.length) return;
        activeIndex = index;
        panels.forEach(function (panel, panelIndex) {
          panel.classList.toggle('is-active', panelIndex === index);
        });
        controls.forEach(function (control, controlIndex) {
          var isActive = controlIndex === index;
          control.classList.toggle('is-active', isActive);
          control.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function applyMode() {
        var canEnhance = window.innerWidth >= 990 && !reducedMotion && !saveData;
        story.classList.toggle('is-enhanced', canEnhance);
        story.classList.toggle('is-reduced-motion', reducedMotion);
        story.classList.toggle('is-save-data', saveData);
        if (enhanced) enhanced.setAttribute('aria-hidden', canEnhance ? 'false' : 'true');
        if (fallback) fallback.setAttribute('aria-hidden', canEnhance ? 'true' : 'false');
        if (canEnhance) activate(activeIndex);
      }

      controls.forEach(function (control) {
        var index = parseInt(control.getAttribute('data-zs-manufacturing-control'), 10);
        control.addEventListener('mouseenter', function () { activate(index); });
        control.addEventListener('focus', function () { activate(index); });
        control.addEventListener('click', function () { activate(index); });
      });

      if ('IntersectionObserver' in window) {
        var readyObserver = new IntersectionObserver(function (entries) {
          if (!entries[0] || !entries[0].isIntersecting) return;
          story.classList.add('is-ready');
          readyObserver.disconnect();
        }, { rootMargin: '160px 0px', threshold: 0 });
        readyObserver.observe(story);
      } else {
        story.classList.add('is-ready');
      }

      window.addEventListener('resize', function () {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(applyMode);
      });
      applyMode();
    }

    function initManufacturingStories() {
      document.querySelectorAll('[data-zs-manufacturing-story]').forEach(initManufacturingStory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initManufacturingStories, { once: true });
    } else {
      initManufacturingStories();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
